import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export function TopBar({ title }: { title?: string }) {
  const { user, subscription, credits } = useAuth();
  const isPaid =
    subscription &&
    (subscription.plan === "pro_talent" || subscription.plan === "team_fit" || subscription.plan === "scale_up") &&
    (subscription.status === "active" || subscription.status === "trialing");

  return (
    <header className="safe-top sticky top-0 z-30 border-b border-slate-100 bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3 sm:px-6 lg:px-8">
        <Link to={user?.role === "company" ? "/company" : "/app"} className="flex items-center gap-2">
          <LogoMark className="h-7 w-7 rounded-md object-contain" />
          <span className="text-[15px] font-bold tracking-tight text-navy sm:text-base">
            personaw
          </span>
        </Link>

        {title && <h1 className="hidden text-sm font-semibold text-navy sm:block sm:text-base">{title}</h1>}

        <div className="flex items-center gap-2.5">
          {user?.role === "talent" && (
            <div>
              {isPaid ? (
                <Link
                  to="/pricing"
                  className="inline-flex items-center gap-1 rounded-full border border-teal/20 bg-teal/10 px-2.5 py-1 text-xs font-semibold text-teal-dark transition hover:bg-teal/20"
                >
                  <span>✨ Pro Plan</span>
                </Link>
              ) : (
                <Link
                  to="/pricing"
                  className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold transition ${
                    (credits?.interview_credits ?? 0) === 0 || (credits?.report_credits ?? 0) === 0
                      ? "border-rose-300 bg-rose-50 text-rose-700 hover:bg-rose-100"
                      : "border-slate-200 bg-slate-50 text-slate-700 hover:bg-slate-100"
                  }`}
                >
                  <span className="text-[11px]">💳 Chat: {credits?.interview_credits ?? 0}</span>
                  <span className="text-slate-300">·</span>
                  <span className="text-[11px]">Report: {credits?.report_credits ?? 0}</span>
                  <span className="ml-1 font-bold text-teal">Upgrade →</span>
                </Link>
              )}
            </div>
          )}

          <Link to="/app/settings" className="flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-slate-100 sm:h-9 sm:w-9">
            {user?.avatar_url ? (
              <img src={user.avatar_url} alt={user.name} className="h-full w-full object-cover" />
            ) : (
              <span className="text-xs font-semibold text-slate-500">{user?.name?.[0] ?? "?"}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}

export function LogoMark({ className = "h-6 w-6 object-contain rounded" }: { className?: string }) {
  return <img src="/logo.png" alt="personaw" className={className} />;
}
